module.exports = __webpack_public_path__ + "static/media/Icono sucursales.5d36c1c0.svg";